/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
export interface ISocialIconState {
    copyLinkClick: boolean;
}

/**
 * SocialIconsState Input Action
 */
export class SocialIconsStateInput implements IActionInput {
    public getCacheKey = () => `SocialIconsState`;
    public getCacheObjectType = () => 'SocialIconsState';
    public dataCacheType = (): CacheType => 'request';
}

//   Create a data model here or import one to capture the response of the action
export async function socialIconStateAction(input: SocialIconsStateInput, ctx: IActionContext): Promise<ISocialIconState> {
    return { copyLinkClick: false };
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new SocialIconsStateInput();
};

export default createObservableDataAction<ISocialIconState>({
    action: <IAction<ISocialIconState>>socialIconStateAction,
    //   Give your data action a unique id
    id: 'SocialIconsState',
    input: createInput
});
